import { Component, input } from '@angular/core';

import { AlertType } from '../../models/alert-type';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  public readonly message = input<string>();
  public readonly type = input<AlertType>('danger');

  get icon(): string {
    switch (this.type()) {
      case 'info':
        return 'info-circle';
      case 'warning':
      case 'danger':
        return 'exclamation-triangle';
    }
  }
}
